import { createContext, useContext, useState, useCallback } from "react";

const initialFormData = {
  setAllowNavigationDashboard: true,
  isNavbarHidden: false,
};

const AppContext = createContext({
  formData: initialFormData,
  setFormData: () => { },
});

export const AppProvider = ({ children }) => {
  const [appData, setAppData] = useState(initialFormData);

  const updateAppData = useCallback((newData) => {
    // console.log('=== AppContext updateAppData Called ===');
    // console.log('Previous appData:', appData);
    // console.log('New data to merge:', newData);
    setAppData((prevData) => {
      const updated = { ...prevData, ...newData };
      // console.log('Updated appData:', updated);
      return updated;
    });
  }, []); // Empty dependency array since we use setAppData in functional form

  return (
    <AppContext.Provider value={{ appData, setAppData, updateAppData }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within a AppProvider");
  }
  return context;
};
